export default {
  label: {
    noPostsLabel: 'No se encontraron publicaciones',
  },
};
